import { TuiInputDate, TuiInputDateTime, TuiTooltip } from '@taiga-ui/kit';
import {
  TuiHint,
  TuiTextfield,
  TuiLabel,
  TuiIcon,
  TuiCalendar,
} from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { WorkflowFormFieldInputDatetime } from '@features/requests/request-form/components/request-form-workflows/types';
import { IsoStringTuiDateTimeTransformerDirective } from '@core/directives';

@Component({
  selector: 'x-input-datetime-field',
  imports: [
    TuiTextfield,
    TuiLabel,
    TuiIcon,
    TuiTooltip,
    TuiCalendar,
    ReactiveFormsModule,
    TuiInputDateTime,
    TuiHint,
    TuiInputDate,
    IsoStringTuiDateTimeTransformerDirective,
  ],
  templateUrl: './input-datetime-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputDatetimeFieldComponent {
  field = input.required<WorkflowFormFieldInputDatetime>();
  control = input.required<FormControl<any>>();
}
